import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import Join from "@/pages/Join";
import Portal from "@/pages/Portal";
import Faqs from "@/pages/Faqs";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import { About, ContactUs, Superannuation, Services, RecruitmentCompany, Policy } from "@/pages/ContentPages";

export default function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/join" element={<Join />} />
                <Route path="/portal" element={<Portal />} />
                <Route path="/about" element={<About />} />
                <Route path="/superannuation" element={<Superannuation />} />
                <Route path="/faqs" element={<Faqs />} />
                <Route path="/contact-us" element={<ContactUs />} />
                <Route path="/services" element={<Services />} />
                <Route path="/recruitment-company" element={<RecruitmentCompany />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/privacy-policy" element={<Policy title="Privacy Policy" />} />
                <Route path="/disclaimer" element={<Policy title="Disclaimer" />} />
                <Route path="/admin" element={<Admin />} />
            </Routes>
        </BrowserRouter>
    );
}
